var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmhAudioWave({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "audio playback / package page/audio playback/package page/System/Line/Audio"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3L11 21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21V3Z",
    fill: "#A5ACBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4C16.5523 4 17 4.44772 17 5V19C17 19.5523 16.5523 20 16 20C15.4477 20 15 19.5523 15 19V5C15 4.44772 15.4477 4 16 4Z",
    fill: "#A5ACBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 8C9 7.44772 8.55229 7 8 7C7.44772 7 7 7.44772 7 8L7 16C7 16.5523 7.44772 17 8 17C8.55228 17 9 16.5523 9 16L9 8Z",
    fill: "#A5ACBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 9C4.55228 9 5 9.44772 5 10L5 14C5 14.5523 4.55228 15 4 15C3.44772 15 3 14.5523 3 14V10C3 9.44772 3.44772 9 4 9Z",
    fill: "#A5ACBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20.5523 10 21 10.4477 21 11V13C21 13.5523 20.5523 14 20 14C19.4477 14 19 13.5523 19 13V11C19 10.4477 19.4477 10 20 10Z",
    fill: "#A5ACBB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmhAudioWave);
export default __webpack_public_path__ + "static/media/fmh-audio-wave.4679d5c7c05a4abc599f45ef48d5cbad.svg";
export { ForwardRef as ReactComponent };